module.exports = __webpack_public_path__ + "static/media/icn-reports-selected.1a94aa3e.svg";